import { APICallV2Post } from '../APICall';

export class MountFolderApiCall extends APICallV2Post {
    _method = 'folder/mount';
}
